<template>
  <div v-if="sorting">
    <icon v-if="direction === 'desc'" width="12" height="12" type="arrow-up" path="arrows" />
    <icon v-if="direction === 'asc'" width="12" height="12" type="arrow-down" path="arrows" />
  </div>
</template>

<script>
  export default {
    name: 'TableSort',
    data() {
      return {

      };
    },
    props: {
      sorting: {
        type: Boolean,
        required: true,
      },
      direction: {
        type: String,
        required: false,
      },
    },
  };
</script>
